import { SET_TIME } from '../actions.type';

const state = {
  currentTime: 0
};

const getters = {
  currentTime(state) {
    return state.currentTime;
  }
};

const actions = {
  [SET_TIME](context, time) {
    context.commit(SET_TIME, time);
  }
};

const mutations = {
  [SET_TIME](state, time) {
    state.currentTime = time;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/time.js